<template>
<b-row>
  <b-col cols="1"><span class="text-danger" style="font-size: 50px; font-weight: 700;">2</span></b-col>
  <b-col md="11" lg="6" class="pt-3">
    <b-btn block href="#" v-b-toggle.stack-accordion-02 variant="outline-danger" class="text-danger rounded-0 py-0" style="font-size: 24px; font-weight: 700">
      <b-row align-v="center">
        <div class="bg-danger" style="height: 50px; width: 50px;">
          <div class="pt-1"><img src="/images/solid_logo_red.png" height="30"></div>
        </div>
        <div style="text-align: left">
          Solid Pod Collaboration
          <font-awesome-icon :icon="iconCaretDown" size="1" />
        </div>
      </b-row>
    </b-btn>
  </b-col>
  <b-row>
    <b-col cols="11" offset="1">
      <b-collapse id="stack-accordion-02" accordion="stack-accordion" class="px-3">
        <h2 style="color: #2e145e;">Secure Global Collaboration</h2>
        <p>Whether hosted on the cloud or on a machine you manage, own your data with complete control over who and which apps you collaborate with using Solid's global access control.</p>
        <p>
          Collaborate with the whole supply chain on the Owner's Asset Pod (Digital Twin) where all needed information is available while syncing your work back to your own pod.
        </p>
        <img src="/images/solid_collaboration_diagram.png" class="img-fluid">
      </b-collapse>
    </b-col>
  </b-row>
</b-row>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
export default {
  name: 'stack02',
  components: {
      FontAwesomeIcon
    },
    data () {
      return {
        iconCaretDown: faCaretDown
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a.text-danger:hover {
  color: #f8f9fa !important;
}
</style>
